/**
 * SR Overlay Search V1 — Fristående, ingen Noor-hijack.
 * Full kontroll: eget overlay, AbortController, feature flag.
 */
(function () {
  'use strict';

  // --- INIT GUARD ---
  if (window.__srOverlayInit) return;
  window.__srOverlayInit = true;

  // --- CONFIG ---
  var API = (window.SR_SEARCH_API || 'https://skinroller-search.skinroller.workers.dev').replace(/\/$/, '');
  var DEBOUNCE_MS = 180;
  var MIN_QUERY = 2;

  // --- FPID (first-party identity for personalization) ---
  function getFPID() {
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
      var c = cookies[i].trim();
      // Priority: _skinroller_cid > _shopify_y > _ga
      if (c.startsWith('_skinroller_cid=')) return c.substring(15);
      if (c.startsWith('_shopify_y=')) return c.substring(11);
    }
    for (var i = 0; i < cookies.length; i++) {
      var c = cookies[i].trim();
      if (c.startsWith('_ga=')) return c.substring(4);
    }
    return null;
  }
  var fpid = getFPID();
  var fpidParam = fpid ? '&fpid=' + encodeURIComponent(fpid) : '';

  // --- CART EXCLUSION (don't show products already in cart) ---
  var cartHandles = new Set();
  function refreshCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      cartHandles = new Set(cart.items.map(function (i) { return i.handle; }));
    }).catch(function () {});
  }
  refreshCart();

  // --- STATE ---
  var currentSearchId = null;
  var abortCtrl = null;
  var debounceTimer = null;
  var lastRenderedQuery = '';
  var overlayEl, inputEl, bodyEl;

  // --- TRANSLATIONS ---
  var LANG = (function () {
    var el = document.getElementById('sr-overlay-translations');
    if (el) try { return JSON.parse(el.textContent); } catch (e) {}
    return {};
  })();
  var DEFAULTS = {
    popular: 'Populära just nu',
    products: 'Produkter',
    product_singular: 'produkt',
    product_plural: 'produkter',
    collections: 'Samlingar',
    type: 'Typ',
    skin_concern: 'Hudbehov',
    vendor: 'Varumärke',
    no_results: 'Inga resultat för',
    try_other: 'Försök med andra sökord',
    did_you_mean: 'Menade du',
    sold_out: 'Slutsåld',
    view_all: 'Visa alla resultat',
    placeholder: 'Sök produkter, ingredienser...',
    loading: 'Söker...',
    trending: 'TRENDING SEARCHES',
    show_sold_out: 'Visa slutsålda produkter',
  };
  function t(key, arg) {
    var str = LANG[key] || DEFAULTS[key] || key;
    if (arg) str += ' "' + esc(arg) + '"';
    return str;
  }

  // --- OPEN / CLOSE ---
  // iOS keyboard hack: invisible input that captures the initial focus
  var iosFakeInput = document.createElement('input');
  iosFakeInput.style.cssText = 'position:fixed;top:50%;left:0;width:1px;height:1px;opacity:0.01;z-index:-1;';
  iosFakeInput.setAttribute('type', 'text');
  iosFakeInput.setAttribute('inputmode', 'search');
  document.body.appendChild(iosFakeInput);

  function open() {
    if (!overlayEl) return;
    // iOS Safari: focus fake input SYNCHRONOUSLY in click handler to open keyboard
    iosFakeInput.focus();
    overlayEl.classList.add('sr-ov--open');
    document.body.style.overflow = 'hidden';
    // Transfer focus to real input after overlay transition starts
    setTimeout(function () {
      inputEl.focus();
      iosFakeInput.blur();
    }, 50);
    if (inputEl.value.trim().length < MIN_QUERY) {
      loadPopular();
    }
  }
  function close() {
    if (!overlayEl) return;
    overlayEl.classList.remove('sr-ov--open');
    document.body.style.overflow = '';
    if (abortCtrl) abortCtrl.abort();
  }
  function isOpen() {
    return overlayEl && overlayEl.classList.contains('sr-ov--open');
  }

  // --- SEARCH ---
  function onInput() {
    clearTimeout(debounceTimer);
    var q = inputEl.value.trim();

    if (q.length < MIN_QUERY) {
      loadPopular();
      return;
    }

    showLoading();
    debounceTimer = setTimeout(function () { doSearch(q); }, DEBOUNCE_MS);
  }

  function doSearch(q) {
    if (abortCtrl) abortCtrl.abort();
    abortCtrl = new AbortController();

    var stockParam = window.__srShowOos ? '&oos=1' : '&in_stock=true';
    var limitParam = '&limit=8';
    fetch(API + '/search?q=' + encodeURIComponent(q) + limitParam + stockParam + fpidParam, { signal: abortCtrl.signal })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (inputEl.value.trim() !== q) return; // stale
        currentSearchId = data.search_id;
        lastRenderedQuery = q;
        // Filter out products already in cart
        if (data.results) {
          data.results = data.results.filter(function (r) { return !cartHandles.has(r.handle); });
          data.count = data.results.length;
        }
        renderResults(data);
      })
      .catch(function (err) {
        if (err.name === 'AbortError') return;
        renderError();
      });
  }

  // --- TRENDING SEARCHES (hardcoded for V1, dynamic from analytics in V2) ---
  var TRENDING_SEARCHES = [
    'Vitamin C Serum',
    'Niacinamide 10%',
    'Anti-aging Routine',
    'Microneedling Tool',
    'Pink Clay Mask',
  ];

  function loadPopular() {
    renderTrending();
  }

  function renderTrending() {
    var trendIcon = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" style="opacity:0.35;flex-shrink:0;"><polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/><polyline points="16 7 22 7 22 13"/></svg>';

    var h = '<div class="sr-ov__trending-label">' + t('trending') + '</div>';
    h += '<div class="sr-ov__trending-list">';
    TRENDING_SEARCHES.forEach(function (term) {
      h += '<button class="sr-ov__trending-item" data-sr-trending="' + esc(term) + '">' +
        trendIcon +
        '<span>' + esc(term) + '</span>' +
      '</button>';
    });
    h += '</div>';

    bodyEl.innerHTML = h;

    // Click on trending term → search it
    bodyEl.querySelectorAll('[data-sr-trending]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        inputEl.value = btn.dataset.srTrending;
        onInput();
      });
    });
  }

  // --- RENDER: RESULTS ---
  function renderResults(data) {
    if (!data.results || data.results.length === 0) {
      renderEmpty(data);
      return;
    }

    var h = '';

    // Build handle→title map from product data
    var titleMap = {};
    data.results.forEach(function (p) {
      var handles = p.collections || [];
      var titles = p.collection_titles || [];
      for (var i = 0; i < handles.length; i++) {
        if (handles[i] && titles[i]) titleMap[handles[i]] = titles[i];
      }
    });

    // COLLECTIONS pills
    if (data.matching_collections && data.matching_collections.length > 0) {
      h += '<div class="sr-ov__section">';
      h += '<div class="sr-ov__section-label">' + t('collections') + '</div>';
      h += '<div class="sr-ov__pills">';
      data.matching_collections.forEach(function (c) {
        h += '<a class="sr-ov__pill" href="/collections/' + c.handle + '">' + esc(c.title) + '</a>';
      });
      h += '</div></div>';
    }

    // PRODUCT TYPE pills
    if (data.facets && data.facets.product_type && data.facets.product_type.length > 0) {
      h += '<div class="sr-ov__section">';
      h += '<div class="sr-ov__section-label">' + t('type') + '</div>';
      h += '<div class="sr-ov__pills">';
      data.facets.product_type.slice(0, 6).forEach(function (f) {
        h += '<a class="sr-ov__pill" href="/search?q=' + encodeURIComponent(data.query) + '&type=' + encodeURIComponent(f.value) + '">' + esc(f.value) + ' (' + f.count + ')</a>';
      });
      h += '</div></div>';
    }

    // SKIN CONCERN pills (from related collections)
    if (data.facets && data.facets.collection && data.facets.collection.length > 0) {
      var shownHandles = (data.matching_collections || []).map(function (c) { return c.handle; });
      var related = data.facets.collection.filter(function (f) { return shownHandles.indexOf(f.value) === -1; });
      if (related.length > 0) {
        h += '<div class="sr-ov__section">';
        h += '<div class="sr-ov__section-label">' + t('skin_concern') + '</div>';
        h += '<div class="sr-ov__pills">';
        related.slice(0, 6).forEach(function (f) {
          var title = titleMap[f.value] || f.value.replace(/-/g, ' ').replace(/\b\w/g, function (l) { return l.toUpperCase(); });
          h += '<a class="sr-ov__pill" href="/collections/' + f.value + '">' + esc(title) + '</a>';
        });
        h += '</div></div>';
      }
    }

    // Stock toggle
    var hideOos = !window.__srShowOos;
    h += '<label class="sr-ov__stock-toggle"><input type="checkbox" id="sr-ov-oos-toggle"' + (window.__srShowOos ? ' checked' : '') + '> <span>' + t('show_sold_out') + '</span></label>';

    // PRODUCTS (X RESULTS) + VIEW ALL
    h += '<div class="sr-ov__products-header">';
    h += '<div class="sr-ov__products-label">' + t('products').toUpperCase() + ' (' + data.count + ' ' + (data.count === 1 ? t('product_singular') : t('product_plural')).toUpperCase() + ')</div>';
    h += '<a class="sr-ov__viewall-link" href="/search?q=' + encodeURIComponent(data.query || '') + '">' + t('view_all').toUpperCase() + '</a>';
    h += '</div>';

    // Product cards
    data.results.forEach(function (p) { h += buildCard(p); });

    bodyEl.innerHTML = h;
    bindCardClicks();
  }

  // --- RENDER: EMPTY ---
  function renderEmpty(data) {
    var h = '';

    // Did you mean
    if (data.did_you_mean) {
      h += '<div class="sr-ov__dym">' + t('did_you_mean') + ' <a href="#" data-sr-dym="' + esc(data.did_you_mean) + '">' + esc(data.did_you_mean) + '</a>?</div>';
    }

    h += '<div class="sr-ov__empty"><p>' + t('no_results', data.query) + '</p><p class="sr-ov__empty-hint">' + t('try_other') + '</p></div>';

    // Suggested products
    if (data.suggested_products && data.suggested_products.length > 0) {
      h += '<h3 class="sr-ov__heading">' + t('popular') + '</h3>';
      data.suggested_products.forEach(function (p) { h += buildCard(p); });
    }

    bodyEl.innerHTML = h;

    // Did you mean click handler
    var dymLink = bodyEl.querySelector('[data-sr-dym]');
    if (dymLink) {
      dymLink.addEventListener('click', function (e) {
        e.preventDefault();
        inputEl.value = dymLink.dataset.srDym;
        onInput();
      });
    }
  }

  function renderError() {
    bodyEl.innerHTML = '<div class="sr-ov__empty"><p>Något gick fel</p><p class="sr-ov__empty-hint">' + t('try_other') + '</p></div>';
  }

  function showLoading() {
    bodyEl.innerHTML = '<div class="sr-ov__loading">' + t('loading') + '</div>';
  }

  // --- RENDER HELPERS ---
  function renderPillSection(label, items) {
    if (!items || items.length === 0) return '';
    var h = '<div class="sr-ov__pills-section"><div class="sr-ov__pills-label">' + esc(label) + '</div><div class="sr-ov__pills">';
    items.forEach(function (item) {
      h += '<a class="sr-ov__pill" href="' + esc(item.href) + '">' + esc(item.label) + '</a>';
    });
    h += '</div></div>';
    return h;
  }

  function buildCard(product) {
    var imgHtml = product.image_url
      ? '<img class="sr-ov__card-img" src="' + product.image_url + '" alt="' + esc(product.name) + '" loading="lazy">'
      : '<div class="sr-ov__card-img--empty"></div>';

    var priceHtml = renderPrice(product);
    var oosClass = product.in_stock === false ? ' sr-ov__card--oos' : '';
    var oosHtml = product.in_stock === false ? '<span class="sr-ov__oos">' + t('sold_out') + '</span>' : '';

    // Rating (only show if 3+ reviews)
    var ratingHtml = '';
    if (product.rating && product.review_count && product.review_count >= 3) {
      var stars = '';
      for (var i = 1; i <= 5; i++) {
        stars += i <= Math.round(product.rating) ? '★' : '☆';
      }
      ratingHtml = '<div class="sr-ov__rating">' + stars + '</div>';
    }

    return '<a href="/products/' + product.handle + '" class="sr-ov__card' + oosClass + '"' +
      ' data-sr-handle="' + product.handle + '"' +
      ' data-sr-sid="' + (currentSearchId || '') + '">' +
      imgHtml +
      '<div class="sr-ov__card-info">' +
        '<p class="sr-ov__card-name">' + esc(product.name) + '</p>' +
        (product.brand ? '<p class="sr-ov__card-brand">' + esc(product.brand) + '</p>' : '') +
        ratingHtml +
        '<div class="sr-ov__price-row">' + priceHtml + '</div>' +
        oosHtml +
      '</div>' +
    '</a>';
  }

  function renderPrice(p) {
    var price = p.price || 0;
    var compareAt = p.compare_at_price || 0;
    if (compareAt && compareAt > price) {
      var pct = Math.round((compareAt - price) / compareAt * 100);
      return '<span class="sr-ov__price sr-ov__price--sale">' + Math.round(price) + ' kr</span>' +
        '<span class="sr-ov__price--was">' + Math.round(compareAt) + ' kr</span>' +
        '<span class="sr-ov__price--badge">-' + pct + '%</span>';
    }
    return '<span class="sr-ov__price">' + Math.round(price) + ' kr</span>';
  }

  // --- TRACKING ---
  function bindCardClicks() {
    bodyEl.querySelectorAll('[data-sr-handle]').forEach(function (el) {
      el.addEventListener('click', function () {
        var sid = el.dataset.srSid;
        var handle = el.dataset.srHandle;
        if (sid && handle) {
          fetch(API + '/event', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ search_id: sid, event_type: 'click', handle: handle }),
          }).catch(function () {});
        }
      });
    });

    // Stock toggle handler
    var oosToggle = bodyEl.querySelector('#sr-ov-oos-toggle');
    if (oosToggle) {
      oosToggle.addEventListener('change', function () {
        window.__srShowOos = oosToggle.checked;
        // Re-search with current query
        var q = inputEl.value.trim();
        if (q.length >= MIN_QUERY) doSearch(q);
      });
    }
  }

  // --- KEYBOARD ---
  function onKeydown(e) {
    if (!isOpen()) {
      // Open on Ctrl/Cmd+K or /
      if ((e.ctrlKey || e.metaKey) && e.key === 'k') { e.preventDefault(); open(); }
      if (e.key === '/' && !isInputFocused()) { e.preventDefault(); open(); }
      return;
    }
    if (e.key === 'Escape') { close(); return; }

    // Arrow navigation in results
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      var cards = bodyEl.querySelectorAll('.sr-ov__card');
      if (cards.length === 0) return;
      var focused = bodyEl.querySelector('.sr-ov__card:focus');
      var idx = Array.from(cards).indexOf(focused);
      if (e.key === 'ArrowDown') idx = Math.min(idx + 1, cards.length - 1);
      else idx = Math.max(idx - 1, -1);
      if (idx === -1) { inputEl.focus(); } else { cards[idx].focus(); }
    }
  }

  function isInputFocused() {
    var tag = (document.activeElement || {}).tagName;
    return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT';
  }

  // --- UTILITIES ---
  function esc(str) {
    if (!str) return '';
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  // --- EXPOSE FOR PIXEL TRACKING ---
  window.SkinrollerSearch = {
    trackPurchase: function (searchId, handle, revenue) {
      fetch(API + '/event', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ search_id: searchId, event_type: 'purchase', handle: handle, revenue: revenue }),
      }).catch(function () {});
    },
    trackAddToCart: function (searchId, handle) {
      fetch(API + '/event', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ search_id: searchId, event_type: 'add_to_cart', handle: handle }),
      }).catch(function () {});
    },
    open: open,
    close: close,
  };

  // --- INIT ---
  function init() {
    overlayEl = document.getElementById('sr-overlay');
    if (!overlayEl) return;

    inputEl = overlayEl.querySelector('.sr-ov__input');
    bodyEl = overlayEl.querySelector('.sr-ov__body');
    if (!inputEl || !bodyEl) return;

    // Input
    inputEl.addEventListener('input', function () {
      // Show/hide clear button
      var clearBtn = overlayEl.querySelector('.sr-ov__clear');
      if (clearBtn) clearBtn.classList.toggle('sr-ov__clear--visible', inputEl.value.length > 0);
      onInput();
    });

    // Clear button
    var clearBtn = overlayEl.querySelector('.sr-ov__clear');
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        inputEl.value = '';
        clearBtn.classList.remove('sr-ov__clear--visible');
        inputEl.focus();
        loadPopular();
      });
    }

    // Close handlers
    overlayEl.querySelector('.sr-ov__close').addEventListener('click', close);
    overlayEl.addEventListener('click', function (e) { if (e.target === overlayEl) close(); });

    // Keyboard
    document.addEventListener('keydown', onKeydown);

    // Open triggers — delegated capture listener to beat Noor's web components
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-sr-overlay-open]');
      if (trigger) {
        e.preventDefault();
        e.stopImmediatePropagation();
        open();
      }
    }, true); // capture phase — fires before Noor's listeners

    console.log('[SR] Overlay V1 ready');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
